export const OFFLINE_FEE = 'OFFLINE_FEE';
export const ER_OFFLINE_FEE = 'ER_OFFLINE_FEE';
export const THALYS_PASS_CAN_FEE = 'TH_TP_CAN_FEE';

export const OFFLINE_FEE_DETAILS_REASON = 'sale_reason';
export const OFFLINE_FEE_DETAILS_VALUE = 'OE_saleoverride';
